export enum EPromotionStatus {
	ACTIVE = 'active',
	INACTIVE = 'inactive',
	EXPIRED = 'expired',
	DEPLETED = 'depleted',
}

export const PromotionStatusMap: Record<EPromotionStatus, string> = {
	[EPromotionStatus.ACTIVE]: 'Aktywny',
	[EPromotionStatus.INACTIVE]: 'Nieaktywny',
	[EPromotionStatus.EXPIRED]: 'Wygasły',
	[EPromotionStatus.DEPLETED]: 'Wyczerpany',
}

export const PromotionStatuses = generateSelectOptions(EPromotionStatus, PromotionStatusMap)

export enum EPromotionType {
	FIXED = 'cart_fixed_discount',
	PERCENTAGE = 'cart_percentage_discount',
	TIERED_PERCENTAGE = 'tiered_percentage_discount',
}

export const PromotionTypeMap: Record<EPromotionType, string> = {
	[EPromotionType.FIXED]: 'Kwotowy',
	[EPromotionType.PERCENTAGE]: 'Procentowy',
	[EPromotionType.TIERED_PERCENTAGE]: 'Procentowa zniżka wielopoziomowa',
}

export const PromotionTypes = generateSelectOptions(EPromotionType, PromotionTypeMap)

export enum EPromotionTabs {
	GENERAL = 'general',
	RULES = 'rules',
	LIMITS = 'limits',
	USAGE = 'usage',
	ANALYSIS = 'analysis',
}

export enum EPromotionLimit {
	NO_LIMIT = 'no_limit',
	LIMIT = 'limit',
}

export const PromotionLimitMap: Record<EPromotionLimit, string> = {
	[EPromotionLimit.NO_LIMIT]: 'Bez limitu',
	[EPromotionLimit.LIMIT]: 'Limit',
}

export const PromotionLimits = generateSelectOptions(EPromotionLimit, PromotionLimitMap)

export enum EPromotionActionType {
	FIXED = 'cart_fixed_discount',
	PERCENTAGE = 'cart_percentage_discount',
}

export const PromotionActionTypeMap: Record<EPromotionActionType, string> = {
	[EPromotionActionType.FIXED]: 'Kwotowy',
	[EPromotionActionType.PERCENTAGE]: 'Procentowy',
}

export const PromotionActionTypes = generateSelectOptions(EPromotionActionType, PromotionActionTypeMap)

export enum EDiscountCodeTab {
	LIST = 'list',
	ARCHIVE = 'archive',
}
